import React, { useCallback, useEffect, useState } from 'react';
import styles from 'components/nonPodiatry/page.module.scss';
import Button from 'components/common/button';
import { StateType } from 'reducer';
import { NonPodiatryOptionsType } from 'types/types';
import { usePersistNonPodiatryReducer } from 'reducer/nonPodiatry';
import clsx from 'clsx';
import MetaTag from 'components/meta';

type Props = {
  options: NonPodiatryOptionsType[] | NonPodiatryOptionsType;
  nextPage: number;
  isFilter?: boolean;
  actionPage: string;
  nextOrSubmitButton: (nextPage: number, submit?: boolean) => void;
};

function WhichSideScreen({
  options,
  nextPage,
  isFilter = true,
  actionPage,
  nextOrSubmitButton,
}: Props) {
  const [title, setTitle] = useState('');
  const [subTitle, setSubTitle] = useState<string | null>('');
  const [questionItems, setQuestionItems] = useState<string[]>([]);
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const [error, setError] = useState<boolean>(false);

  const [state, dispatch] = usePersistNonPodiatryReducer();

  useEffect(() => {
    if (isFilter && Array.isArray(options)) {
      const findObject = options.find(
        (obj: NonPodiatryOptionsType) => obj.name === actionPage,
      );
      if (findObject) {
        try {
          setQuestionItems(findObject.options);
          setTitle(findObject.title);
          setSubTitle(findObject.subTitle);
        } catch (error) {
          console.error('🚀 ~ Error on filter options', error);
        }
      }
    } else if (!Array.isArray(options)) {
      setQuestionItems(options.options);
      setTitle(options.title);
      setSubTitle(options.subTitle);
    }
  }, []);

  useEffect(() => {
    if (state) {
      const getWhichSide = state.find(
        (object: StateType) => object.name === actionPage,
      );
      setSelectedItems(getWhichSide.value);
    }
  }, []);

  const onSelectOptions = useCallback((item: string) => {
    setSelectedItems([item]);
    setError(false);
  }, []);

  const clickNextOrSubmit = async () => {
    if (selectedItems.length === 0) {
      setError(true);
      return;
    }
    await dispatch({
      type: actionPage,
      name: title,
      value: selectedItems,
    });
    nextOrSubmitButton(nextPage);
  };

  return (
    <>
      <MetaTag title={title} />
      <h2 className={`marginTopZero ${styles.titleText}`}>
        {title}
      </h2>
      <p className={styles.titleTextSubText}>{subTitle}</p>
      {error && (
      <p className="error-message">
        Please select at least one option.
      </p>
      )}
      <div>
        {questionItems.map((item) => {
          const isSelected = selectedItems.includes(item);
          return (
            <p
              key={item}
              className={clsx('option', { 'selected-option': isSelected })}
              onClick={() => onSelectOptions(item)}
              onKeyUp={() => onSelectOptions(item)}
            >
              {item}
            </p>
          );
        })}
      </div>
      <div className="next-button-fixed">
        <Button onClick={clickNextOrSubmit}>
          Next
        </Button>
      </div>
    </>
  );
}

export default WhichSideScreen;
